module.exports = __webpack_public_path__ + "img/icon_2_3.ba5ff74b.png";